import EventCard from "@/components/base/EventCard";
import { events } from "@/mocks/events";
import type { EventItem } from "@/types/content";

export default function RelatedEvents({ current }: { current: EventItem }) {
  const sameCategory = events.filter((e) => e.category === current.category && e.id !== current.id);
  const others = events.filter((e) => e.category !== current.category && e.id !== current.id);
  const related = [...sameCategory, ...others].slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="mt-12">
      <div className="mb-6 flex items-end justify-between gap-4">
        <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">接着看这些现场</h2>
        <span className="hidden text-sm text-foreground-500 sm:block">同类事件的评论区同样精彩</span>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {related.map((item) => (
          <EventCard key={item.id} event={item} />
        ))}
      </div>
    </section>
  );
}